import { render, staticRenderFns } from "./sqnewexamdetail.vue?vue&type=template&id=a97e777c&scoped=true&"
import script from "./sqnewexamdetail.vue?vue&type=script&lang=js&"
export * from "./sqnewexamdetail.vue?vue&type=script&lang=js&"
import style0 from "./sqnewexamdetail.vue?vue&type=style&index=0&id=a97e777c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97e777c",
  null
  
)

export default component.exports